import { useQuery } from './useQuery';

export const useEmbedParams = () => {
  const queryParams = useQuery();
  const hideSideNav = queryParams.get('hide_side_nav') === 'true';
  const hideHeader = queryParams.get('hide_header') === 'true';
  const modal = queryParams.get('modal');
  const component = queryParams.get('component');
  return {
    hideSideNav,
    hideHeader,
    modal,
    component,
  };
};
